import PaymentList from './payment.list';

export default {
  list: PaymentList,
  create: false,
  show: false,
  edit: false,
};
